const platform = resolve => require(['@/components/station/platform/index.vue'], resolve);
export default [{
    path: "/homeMain/station/platform",
    component: platform,

}, ]


// WEBPACK FOOTER //
// ./src/router/station.js